var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.8 10.2 9-9.3c.4-.4 1 0 .8.5l-2.4 6c-.1.2.2.6.5.6h6.2c.4 0 .7.5.4.8l-8.9 10c-.4.4-1 0-.8-.5l2.7-6.7c.1-.3-.1-.7-.5-.7H3.2c-.5.1-.7-.4-.4-.7z"
  })));
};
export default SvgBolt;